
















import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import SearchProducer from '@/mixins/search-queries/search-producer'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { IQuoteSourceInput } from '@/modules/Quote/interfaces/quote-form'

@Component({
  components: {
    AppTextSearch
  }
})
export default class QuoteFormSource extends mixins(SearchProducer) {
  @Prop({ type: Object as () => IQuoteSourceInput }) value!: IQuoteSourceInput
  @Prop({ type: Object as () => Producer }) readonly source!: Producer

  get sourceDisable () {
    return !!this.source
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
